import React, { useState } from "react";
import { FaPenToSquare, FaCheck, FaX, FaRegTrashCan } from "react-icons/fa6";
import { API_tecnicos } from "../../config/apiConfig";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthContext";

const ListadoTecnicos = ({ tecnico, onActualizar, onEliminar, isAdmin }) => {
  const { token } = useAuth();
  const [modoEdicion, setModoEdicion] = useState(false);
  const [valores, setValores] = useState({
    role: tecnico.role,
    employeeStatus: tecnico.employeeStatus?.toLowerCase() || "activo",
  });

  const handleChange = (field, value) => {
    setValores((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    try {
      const res = await fetch(`${API_tecnicos}/${tecnico.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", "x-auth-token": token },
        body: JSON.stringify({
          role: valores.role,
          employeeStatus:
            valores.employeeStatus === "activo" ? "Activo" : "Inactivo",
        }),
      });
      if (!res.ok) throw new Error("Error al actualizar técnico");

      toast.success("Datos actualizados correctamente");
      onActualizar(tecnico.id, valores); // Actualiza en el estado del padre
      setModoEdicion(false);
    } catch (err) {
      console.error(err);
      toast.error("No se pudieron guardar los cambios");
    }
  };

  const handleCancel = () => {
    setModoEdicion(false);
    setValores({
      role: tecnico.role,
      employeeStatus: tecnico.employeeStatus?.toLowerCase() || "activo",
    });
  };

  const handleDelete = () => {
    onEliminar(tecnico.id, `${tecnico.name} ${tecnico.lastName}`);
  };

  return (
    <tr>
      <td className="w-250">
        {tecnico.name} {tecnico.lastName}
      </td>
      <td className="w-300">{tecnico.email}</td>

      {modoEdicion ? (
        <>
          <td className="w-175">
            <select
              value={valores.role}
              onChange={(e) => handleChange("role", e.target.value)}
            >
              <option value="tecnico-1">tecnico-1</option>
              <option value="tecnico-2">tecnico-2</option>
              <option value="administrador">administrador</option>
            </select>
          </td>
          <td className="w-150">
            <select
              value={valores.employeeStatus}
              onChange={(e) => handleChange("employeeStatus", e.target.value)}
            >
              <option value="activo">activo</option>
              <option value="inactivo">inactivo</option>
            </select>
          </td>
          <td>
            <div className="check flex gap-5">
              <button className="fondo-blanco verde" onClick={handleSave}>
                <FaCheck />
              </button>
              <button className="fondo-blanco rojo" onClick={handleCancel}>
                <FaX />
              </button>
            </div>
          </td>
        </>
      ) : (
        <>
          <td className="w-175">{tecnico.role}</td>
          <td className="w-150">{tecnico.employeeStatus || "activo"}</td>
          <td>
            <div className="flex gap-5">
              {isAdmin && (
                <FaPenToSquare
                  aria-label="Editar"
                  className="editar fondo-blanco cursor"
                  onClick={() => setModoEdicion(true)}
                />
              )}
              {isAdmin && (
                <FaRegTrashCan
                  aria-label="Eliminar"
                  className="eliminar fondo-blanco cursor rojo"
                  onClick={handleDelete}
                />
              )}
            </div>
          </td>
        </>
      )}
    </tr>
  );
};

export default ListadoTecnicos;
